import React from 'react';
import { motion } from 'framer-motion';
import ApiMonitorDashboard from '@/components/ApiMonitorDashboard';

function Settings() {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
      <ApiMonitorDashboard />
    </motion.div>
  );
}

export default Settings;